import apiClient from "./apiClient";

// invoices
export const getInvoices = (page = 1, limit = 30) => apiClient
  .get("/invoices", { params: { page, limit } })
  .then(res => res);
export const getInvoicesByPetId = (id, page = 1, limit = 30) => apiClient
  .get(`/invoices/pet/${id}`, { params: { page, limit } })
  .then(res => res);
export const getInvoicesByPetOwnerId = (id, page = 1, limit = 30) => apiClient
  .get(`/invoices/pet-owner/${id}`, { params: { page, limit } })
  .then(res => res);
export const getInvoicesByHistoryId = (id, page = 1, limit = 30) => apiClient
  .get(`/invoices/history/${id}`, { params: { page, limit } })
  .then(res => res);
export const getInvoicesByHistoryEntryId = (id, page = 1, limit = 30) => apiClient
  .get(`/invoices/history-entry/${id}`, { params: { page, limit } })
  .then(res => res);
export const getInvoiceById = (id) => apiClient.get(`/invoices/${id}`);
export const createInvoice = (data) => apiClient.post("/invoices", data);
export const updateInvoice = (id, data) => apiClient.put(`/invoices/${id}`, data);
export const deleteInvoice = (id) => apiClient.delete(`/invoices/${id}`);
export const sendInvoiceEmail = (id) => apiClient.post(`/invoices/${id}/email`);

// invoice items
export const createInvoiceItem = (data) => apiClient.post("/invoice-items", data);
export const updateInvoiceItem = (id, data) => apiClient.put(`/invoice-items/${id}`, data);
export const deleteInvoiceItem = (id) => apiClient.delete(`/invoice-items/${id}`);

// invoice payments
export const createInvoicePayment = (data) => apiClient.post("/invoice-payments", data);
export const updateInvoicePayment= (id, data) => apiClient.put(`/invoice-payments/${id}`, data);
export const deleteInvoicePayment = (id) => apiClient.delete(`/invoice-payments/${id}`);

// payment methods
export const getPaymentMethods = () => apiClient.get("payment-methods");
export const createPaymentMethod = (data) => apiClient.post("/payment-methods", data);
export const updatePaymentMethod = (id, data) => apiClient.put(`/payment-methods/${id}`, data);
export const deletePaymentMethod = (id) => apiClient.delete(`/payment-methods/${id}`);

// public
export const getInvoiceByIdAndInvoiceNumber = (id, invoiceId) => apiClient.get(`/invoices/public/${id}/${invoiceId}`);